import type {KernelResult} from "./types";

export type AxisRange = [number, number];
export const COMMON_RANGE: AxisRange = [0, 100];
export const axisValue = (x: number, log: boolean) => log ? Math.log10(x) : x;
export function positiveRange(range: AxisRange, floor = 1): AxisRange {
  const upper = range[1] > 0 ? range[1] : 100;
  return [range[0] > 0 ? range[0] : Math.max(1e-12, Math.min(floor, upper / 10)), upper];
}
export function temperatureAt(range: AxisRange, fraction: number, log: boolean): number {
  return log ? 10 ** (Math.log10(range[0]) + fraction * Math.log10(range[1] / range[0])) : range[0] + fraction * (range[1] - range[0]);
}
export function zoomXRange(range: AxisRange, factor: number, log: boolean, anchor?: number): AxisRange {
  if (!log) return zoomRange(range, factor, anchor);
  const lo = Math.log10(range[0]), hi = Math.log10(range[1]);
  const center = anchor === undefined ? (lo + hi) / 2 : Math.log10(anchor);
  const span = Math.max(.01, Math.min(18, (hi - lo) * factor));
  const fraction = Math.max(0, Math.min(1, (center - lo) / (hi - lo)));
  const min = Math.max(-12, Math.min(6 - span, center - fraction * span));
  return [10 ** min, 10 ** (min + span)];
}
export function panXRange(range: AxisRange, fraction: number, log: boolean): AxisRange {
  if (!log) {const span = range[1] - range[0]; const min = Math.max(0, range[0] - fraction * span); return [min, min + span];}
  const span = Math.log10(range[1] / range[0]);
  const min = Math.max(-12, Math.min(6 - span, Math.log10(range[0]) - fraction * span));
  return [10 ** min, 10 ** (min + span)];
}
export function dataRange(results: KernelResult[]): AxisRange {
  const xs = results.flatMap(r => r.points.map(p => p.tt_ev)).filter(Number.isFinite);
  if (!xs.length) return [...COMMON_RANGE];
  const min = xs.reduce((a, b) => Math.min(a, b), Infinity), max = xs.reduce((a, b) => Math.max(a, b), -Infinity);
  return min === max ? [Math.max(0, min - 1), max + 1] : [Math.min(0, min), max];
}
export function zoomRange(range: AxisRange, factor: number, anchor = (range[0] + range[1]) / 2): AxisRange {
  const span = Math.max(0.01, Math.min(1e6, (range[1] - range[0]) * factor));
  const fraction = Math.max(0, Math.min(1, (anchor - range[0]) / (range[1] - range[0])));
  const min = Math.max(0, anchor - span * fraction);
  return [min, min + span];
}
